import React from "react";
import { useTranslation } from "react-i18next";
import style from "./profile.module.scss";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";

function FormHead(props) {
  console.log("form head props", props)
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const buttonClick = () => {
    props.change(props.status);
  };

  const renderButton = () => {
    if (props.uploadedData) {
      return (
        <Tooltip title="Verified are allowed to modify">
          <button
            className={`${style.editButton}`}
            onClick={buttonClick}
            hidden={!props.show}
            disabled={props.uploadedData}
          >
            <i className="fa fa-pencil"></i>
          </button>
        </Tooltip>
      );
    } else {
      return (
        <button
          className={`${style.editButton}`}
          onClick={buttonClick}
          hidden={!props.show}
          disabled={props.detailsDisable === 0 }
        >
          <i className="fa fa-pencil"></i>
        </button>
      );
    }
  };

  return (
    <div
      className={`${
        currentTheme == "theme-dark"
          ? `${style.dark_mode_FormHead}`
          : `${style.FormHead}`
      }`}
    >
      <h3
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_headeText}`
            : `${style.headeText}`
        }`}
      >
        {t("Common." + props.title)}
      </h3>
      {renderButton()}
    </div>
  );
}

export default FormHead;
